import React, { useState, useEffect } from 'react'
import styled from '@emotion/styled'

import Tabs from '../generic/tabs'
import LicensePlate from './LandingTabs/LicensePlateWithMakeModel'
import VIN from './LandingTabs/VINWithMakeModel'
import MakeModel from './LandingTabs/MakeModel'
import VinLocationModal from './VinLocationModal'
import { useScroller } from '../../hooks'

export default ({
  submitPlateStateForm,
  submitVinNoForm,
  submitYMMForm,
  submitPrefilledForm,
  resetPlateStateVinForm,
  plateStateVinError,
  plateStateVinErrorMessage,
  isErrorNeedUseTradeInValue,
  ymmError,
  vinActiveDealer,
  showMakeModelTab,
  globalState,
  updateGlobalState,
  activeTab,
  urlState,
  trims,
  states,
  setShowModal,
  isAdmin,
  navigateVinClear,
  offer,
  setBackToVin,
  experienceState,
  navigateToNewOfferWithVin,
  argoButtonEnabled,
  isCobrand,
  isRequireVinPlate,
  ...props
}) => {
  const isVinActiveDealer = !!vinActiveDealer && !!vinActiveDealer.totalResultCount && vinActiveDealer.totalResultCount > 0 && !vinActiveDealer.privateSeller && !isAdmin
  const vinActiveDealerUrl = vinActiveDealer && vinActiveDealer.autoListingUrl ? vinActiveDealer.autoListingUrl : ''
  const { year, make, model, trim } = props
  const onClick = (e, fromPrefilled, button, error, barcodeVin) => {
    setTimeout(() => {
      updateGlobalState({ isIneligibleYear: false, fireAnalytics: 'pixall_continue_timbuybkhome_selltrade' })
    }, 500)
    const analyticsTab = button === 'License Plate' ? 'lp' : button === 'VIN' ? 'vin' : button === 'Make/Model' ? 'mm' : ''
    if (!error) {
      globalState.entry = analyticsTab
      setBackToVin(false)
      if (button === 'License Plate') submitPlateStateForm({ plate: globalState.plate, state: globalState.state })
      if (button === 'VIN') submitVinNoForm(barcodeVin || globalState.vin || urlState.vin || (offer && offer.prospect.vehicle.vin))
      if (button === 'Make/Model') submitYMMForm()
    } else {
      updateGlobalState({ fireAnalytics: `continue_timbuybkhome_selltrade_${analyticsTab}_error${button === 'VIN' ? '_vin_char' : '_lp_none'}` })
    }
  }

  //resetType 1 plate, 2 vin, 0 ymm, improve enum later, 0 ymm change already clears vin in url
  const onChange = (updateObject, resetType = 1) => {
    if (updateObject) updateGlobalState({ ...updateObject })
    if (resetType === 0 || resetType) updateGlobalState({ lp: undefined })
    if (resetType) navigateVinClear() //0 ymm change already clears vin in url
    // critical to reset, read usePlateVin hook comments
    resetPlateStateVinForm(resetType)
  }
  const onClickTab = activeTab => onChange({ activeTab, lp: globalState.lp }, false)
  const [displayYMMVIN, setDisplayYmmVIN] = useState(urlState.displayYMM)
  const [displayYMMLP, setDisplayYmmLP] = useState(urlState.displayYMM)

  //TODO: If we ever stop showing make model tab by default on other experiences just remove this showmakemodeltab variable and things should work fine!
  let displayYMM = !showMakeModelTab && ((activeTab === 'VIN' && displayYMMVIN) || (activeTab === 'License Plate' && displayYMMLP))
  displayYMM = false
  const { isDigitalRetail, isCobrandDR, offerCode } = experienceState

  const makeModelProps = { globalState, trims, onChange, isAdmin, error: ymmError, isDisabled: isAdmin, urlState, onClick: e => onClick(e, false, 'Make/Model'), setShowModal, updateGlobalState, isDigitalRetail, isCobrandDR }
  const [setHasScrolled, scroll] = useScroller()

  useEffect(() => {
    const setDisplayYmm = activeTab === 'VIN' ? setDisplayYmmVIN : setDisplayYmmLP
    if (plateStateVinError) {
      setDisplayYmm(true)
    }
    setHasScrolled(true)
    scroll('body', 'top')
  }, [displayYMM, plateStateVinError, activeTab])

  return (
    <>
      <Tabs activeTab={activeTab} onClickTabItem={onClickTab}>
        <LicensePlate
          testId="bi-tab-LicensePlate"
          label="License Plate"
          {...{
            globalState,
            states,
            onChange,
            showMakeModelTab,
            error: globalState.plate && globalState.state && plateStateVinError && !ymmError,
            onClick,
            trims,
            displayYMM,
            argoButtonEnabled,
            updateGlobalState
          }}
        />
        <VIN
          testId="bi-tab-VIN"
          label="VIN"
          {...{
            globalState,
            updateGlobalState,
            urlState,
            offer,
            setShowModal,
            onChange,
            showMakeModelTab,
            errorMessage: plateStateVinErrorMessage,
            isErrorNeedUseTradeInValue,
            year,
            make,
            model,
            trim,
            error: (plateStateVinError && !ymmError) || !!isVinActiveDealer,
            isVinActiveDealer,
            vinActiveDealerUrl,
            onClick,
            isAdmin,
            trims,
            displayYMM,
            submitVinNoForm,
            setBackToVin,
            navigateToNewOfferWithVin,
            argoButtonEnabled,
            loadingInfo: props.loadingInfo,
            offerCode
          }}
        />
        {isCobrand
          ? !plateStateVinErrorMessage && showMakeModelTab && !isErrorNeedUseTradeInValue && !isVinActiveDealer && !isRequireVinPlate && <MakeModel testId="bi-tab-MakeModel" label="Make/Model" {...makeModelProps} {...props} {...experienceState} />
          : !plateStateVinErrorMessage && showMakeModelTab && !isErrorNeedUseTradeInValue && !isVinActiveDealer && <MakeModel testId="bi-tab-MakeModel" label="Make/Model" {...makeModelProps} {...props} {...experienceState} />}
      </Tabs>
      <SpacerDiv>
        {isCobrand
          ? !plateStateVinErrorMessage && displayYMM && !isErrorNeedUseTradeInValue && !isVinActiveDealer && !isRequireVinPlate && <MakeModel label="Make/Model" {...makeModelProps} {...props} {...experienceState} />
          : !plateStateVinErrorMessage && displayYMM && !isErrorNeedUseTradeInValue && !isVinActiveDealer && <MakeModel label="Make/Model" {...makeModelProps} {...props} {...experienceState} />}
      </SpacerDiv>
      <VinLocationModal setShowModal={setShowModal} />
    </>
  )
}

const SpacerDiv = styled.div`
  padding-top: 16px;
  width: 100%;
`
